import React from 'react';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import ESTADOS from './../../data/estados';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';

const URL_LOAD = WS.endereco.load;
const URL_UPDATE = WS.endereco.update;

export default class PageEndereco extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      strings: STRINGS[window.LANGUAGE],
      loaded: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(__args__){
    this.setState({[__args__.name]:__args__.value});
  }

  getItemSelect(__args__) {
    const check = __args__.value;
    let resp;
    const arr = __args__.arr;
    arr.map((value,i)=>{
      if(value.value === check){
        resp = arr[i];
        return false;
      }
    });
    return resp;
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    /*Requisitions({
      url: URL_LOAD,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            ...data.data,
            loaded: true
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });*/
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const data = {...this.state};

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar,
      periodoGratuitoMsg
    }
    = this.state.strings;

    if(!data.uf ||
      !data.cidade ||
      !data.cep ||
      !data.bairro ||
      !data.logradouro){
      var msg = {
        title: atencao,
        text: preenchaCamposAsterisco
      };

      Dialog.create(msg);
      return false;
    }else{
      var msg = {
        title: atencao,
        text: periodoGratuitoMsg
      };
      Dialog.create(msg);
    }
  }

  render(){
    const strings = this.state.strings;

    //-----
    const estadoAtivo = this.state.uf;
    var estado;
    ESTADOS.map((value,i)=>{
      if(value.value === estadoAtivo){
        estado = ESTADOS[i];
        return false;
      }
    });
    //------

    return(
      <div>
        <form className="form-login"  onSubmit={this.handleSubmit}>
          <Select
            key={Math.random()}
            name='uf'
            onChange={(e)=>this.handleSelect({name: 'uf', value: e.value})}
            title={`${strings.txtEstado}*`}
            options={ESTADOS}
            value={estado}
            />

            <TextInput
              value={this.state.cidade}
              onChange={this.handleInputChange}
              name="cidade"
              title={`${strings.txtCidade}*`}
              placeholder={strings.digiteCidade}>
            </TextInput>
            <TextInput
              value={this.state.cep}
              inputMask={{
                name:'cep',
                placeholder: strings.digiteCep,
                mask: "99999-999",
                maskChar: "_"
              }}
              onChange={this.handleInputChange}
              name="cep"
              title={`${strings.txtCep}*`}
              placeholder={strings.digiteCep}>
            </TextInput>
            <TextInput
              value={this.state.bairro}
              onChange={this.handleInputChange}
              name="bairro"
              title={`${strings.txtBairro}*`}
              placeholder={strings.digiteBairro}>
            </TextInput>
            <TextInput
              value={this.state.logradouro}
              onChange={this.handleInputChange}
              name="logradouro"
              title={`${strings.txtLogradouro}*`}
              placeholder={strings.digiteLogradouro}>
            </TextInput>
            <TextInput
              value={this.state.complemento}
              onChange={this.handleInputChange}
              name="complemento"
              title={strings.txtComplemento}
              placeholder={strings.digiteComplemento}>
            </TextInput>
            <TextInput
              value={this.state.numero}
              onChange={this.handleInputChange}
              name="numero"
              title={strings.txtNumero}
              placeholder={strings.digiteNumero}>
            </TextInput>

            <Button
              text={strings.txtSalvar}
              onClick={this.handleSubmit}
              type='submit'
              classes="button-login simple-button"
            />
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/perfil/PageEndereco.js